import ModuleWrapper from 'shared-lib/containers/Module';

const ForeignLeadsCampaigns = () => import(/* webpackChunkName: "foreign-leads-campaigns" */ '@/views/foreignLeads/Campaigns');

const meta = (data = {}) => ({
    privilegeModule: 'foreign_leads',
    permission: 'read',
    auth: true,
    ...data,
});

export default [{
    path: 'foreign-leads',
    component: ModuleWrapper,
    meta: meta({
        title: 'ForeignLeads',
    }),
    children: [
        {
            path: 'campaigns',
            name: 'ForeignLeadsCampaigns',
            component: ForeignLeadsCampaigns,
            meta: meta(),
        },
    ],
}];
